import { render, staticRenderFns } from "./card-with-action-header.vue?vue&type=template&id=175e97af&scoped=true&"
import script from "./card-with-action-header.vue?vue&type=script&lang=js&"
export * from "./card-with-action-header.vue?vue&type=script&lang=js&"
import style0 from "./card-with-action-header.vue?vue&type=style&index=0&id=175e97af&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "175e97af",
  null
  
)

export default component.exports